import styled from 'styled-components';

const SubContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
`;

export default SubContainer;

